import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { SecurityMappingPanelComponent } from './security-mapping-panel.component'

@NgModule({
  imports: [CommonModule, GenericComponentsModule],
  declarations: [SecurityMappingPanelComponent],
  exports: [SecurityMappingPanelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SecurityMappingModule {}

export { SecurityMappingPanelComponent }
